import session from "@/api/ledgerSession";

export default {
  fetchLedgerUser() {
    return session.get(`/users/me/`);
  },

  fetchOnAttempts(filters) {
    return session.get(`/direct-debits/0n/attempts/`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  postOnNewAttempts(payload) {
    return session.post(`/direct-debits/0n/attempts/`, payload);
  },

  fetchOnReadyAccounts() {
    return session.get(`/direct-debits/0n/ready/`);
  },

  downloadOnAttempts({ id, fileId }) {
    return session.get(`/direct-debits/0n/attempts/${id}/files/${fileId}/csv/`, { responseType: 'blob' });
  },

  uploadAuddis({ id, auddis }) {
    const formData = new FormData();
    formData.append('auddis', auddis);
    return session.post(`/direct-debits/0n/attempts/${id}/files/upload/auddis/`, formData, { headers: { 'Content-Type': 'multipart/form-data' }});
  },

  uploadAllEntries({ id, all_entries }) {
    const formData = new FormData();
    formData.append('all_entries', all_entries);
    return session.post(`/direct-debits/0n/attempts/${id}/files/upload/all-entries/`, formData, { headers: { 'Content-Type': 'multipart/form-data' }});
  }
};
